<div fxLayout="row" fxLayoutAlign="left center">
  <div fxLayout="column">
    <!-- File Upload Input -->
	<div *ngIf="vc_editMode">
		<p>Sube el logo de la empresa para usar en los documentos generados.</p>

		<input
		  type="file"
		  (change)="fn_uploadLogo($event)"
		  accept="image/*"
		  style="margin-bottom: 20px; margin-top:20px;"
		/>
	</div>

    <!-- Logo Preview -->
    <img
		*ngIf="!vc_editMode && vc_logoUrl"
		[src]="vc_logoUrl"
		alt="Logo de la empresa"
		style="max-width: 300px; border: 1px solid #ccc; padding: 10px;"
    />

    <br />

    <div fxLayout="row" fxLayoutAlign="end center">
		<!-- Cancel Button (Only in Edit Mode) -->
		<button mat-button (click)="fn_cancelEdit()" *ngIf="vc_editMode && vc_logoUrl">Cancelar</button>
		<!-- Delete Button (Always Available) -->
		<button mat-button (click)="fn_deleteLogo()" *ngIf="!vc_editMode && vc_logoUrl">Eliminar</button>

		<!-- Edit Button (Only when there is a logo) -->
		<button
			mat-raised-button
			color="primary"
			(click)="fn_enableEditMode()"
			*ngIf="!vc_editMode && vc_logoUrl"
		>
			Editar
		</button>

		<!-- Save Button (Only when in edit mode & a new file is selected) -->
		<button
			mat-raised-button
			color="primary"
			(click)="saveLogo()"
			*ngIf="vc_editMode"
			[disabled]="!vc_fileSelected"
		>
			Guardar
		</button>
    </div>
  </div>
</div>
